import React from "react";

const formatPrice = (v) => `${Number(v || 0).toFixed(2)} €`;

const ProductInfoModal = ({ show, product, onClose }) => {
  if (!show || !product) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1060 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0" style={{ backgroundColor: "#f8f9fa", color: "#333", borderRadius: "12px" }}>
          <div className="modal-header border-bottom-0 pt-4 pb-3" style={{ backgroundColor: "#e9ecef", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
            <div className="d-flex align-items-center w-100">
              <div className="bg-white p-2 rounded shadow-sm me-3 flex-shrink-0" style={{ width: "80px", height: "80px" }}>
                <img 
                  src={product.imageUrl || "/img/default.png"} 
                  alt={product.name} 
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </div>
              <div className="flex-grow-1">
                <h4 className="modal-title fw-bold text-dark mb-1">
                  {product.name}
                </h4>
                <div className="text-muted small">
                  Réf: {product.barcode || product.sku || "N/A"}<br/>
                  Stock : {product.stock || 0} - stock standard
                </div>
              </div>
            </div>
            <button type="button" className="btn-close" onClick={onClose} style={{ alignSelf: "flex-start" }}></button>
          </div>
          
          <div className="modal-body p-4 bg-white">
            <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: "#495057" }}>Résumé</h5>
            <p className="text-danger fw-bold mb-4">
              {product.shortDescription || product.description || "Aucun résumé disponible."}
            </p>

            <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: "#495057" }}>Description</h5>
            <div className="text-muted" style={{ minHeight: "100px", whiteSpace: "pre-wrap" }}>
              {product.description || "Aucune description détaillée."}
            </div>
            
            <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
              <div>
                <span className="fs-3 fw-bold text-dark">{formatPrice(product.price)}</span>
                <span className="ms-3 text-muted small">PA: {formatPrice(product.purchasePrice)}</span>
              </div>
            </div>
          </div>
          
          <div className="modal-footer border-top-0 bg-light" style={{ borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px" }}>
            <button 
              type="button" 
              className="btn btn-info text-white fw-bold px-5 py-2 w-100" 
              onClick={onClose}
              style={{ backgroundColor: "#a6dced", borderColor: "#a6dced" }}
            >
              VALIDER
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfoModal;
